import { createAction } from '@reduxjs/toolkit';

export class GetTimeZoneFailure {
  static get action() {
    return createAction('profile/GET_TIME_ZONE_FAILURE');
  }
}
